import { useState } from 'react';

import { GridToolbarContainer, GridToolbarFilterButton, GridToolbarQuickFilter } from '@mui/x-data-grid';
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import SettingsIcon from '@mui/icons-material/Settings';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { getStockLimit, updateStockLimit } from '../../api/api';
import { useToast } from '../../components/ToastContext';

const CustomToolbar = () => {
  const [open, setOpen] = useState(false);
  const [limit, setLimit] = useState();
  const { showToast } = useToast();

  const handleSave = () => {
    updateStockLimit(limit)
      .then(() => handleClose())
      .catch(() => showToast('Something went wrong', 'error'));
  };

  const handleOpen = () => {
    setOpen(true);
    getStockLimit()
      .then((data) => setLimit(data))
      .catch(() => showToast('Something went wrong', 'error'));
  };

  const handleClose = () => setOpen(false);

  return (
    <>
      <GridToolbarContainer sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 1, pb: 4 }}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <Typography style={{ color: '#02331B', fontSize: 24, lineHeight: '32px' }} component="div">
            Product Dashboard
          </Typography>
          <Typography style={{ color: '#6D6D6D', fontSize: 16, lineHeight: '22px' }} component="div">
            Edit each product to update and sent its variants to Skroutz.
          </Typography>
        </div>

        <Box sx={{ flexGrow: 1 }} />

        <Box>
          <GridToolbarQuickFilter sx={{ pr: 1 }} placeholder="Search a product..." variant="outlined" size="small" />
          <GridToolbarFilterButton />
          <IconButton onClick={handleOpen}>
            <SettingsIcon color="success" />
          </IconButton>
        </Box>
      </GridToolbarContainer>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Stock Limit</DialogTitle>
        <DialogContent>
          <Typography sx={{ mb: 2 }} variant="body2" color="textSecondary">
            Define the minimum stock threshold to prevent variants from being sent to Skroutz.
          </Typography>
          <TextField
            type="number"
            value={limit}
            onChange={(e) => setLimit(Number(e.target.value))}
            fullWidth
            size="large"
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button color="inherit" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="contained" color="success" onClick={handleSave} sx={{ boxShadow: 2 }}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CustomToolbar;
